import request from "@/utils/request";
import config from "@/config";
// const token = config.token;

let serveUrl = config.baseUrl;

let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;

// 获取列表
export function getQRcodeList(data) {
    return request({
      url: `https://portal-service.fdzcxy.edu.cn/portalCenter/api/userdata/qrCode/getQRcodeList`,
        // url: `http://192.168.2.82:20001/portalCenter/api/userdata/qrCode/getQRcodeList`,
        headerType: "portal",
        method: "get",
        params: data
    });
}

// 添加
export function saveCode(data){
  return request({
    url: `https://portal-service.fdzcxy.edu.cn/portalCenter/api/userdata/qrCode/save`,
    headerType: 'portal',
    method: 'post',
    data: data
  })
}

//编辑
export function updateCode(data){
  return request({
    url: `https://portal-service.fdzcxy.edu.cn/portalCenter/api/userdata/qrCode/update`,
    headerType: 'portal',
    method: 'post',
    data: data
  })
}


//删除

export function batchDeleteQRcode(data){
  return request({
    url: `https://portal-service.fdzcxy.edu.cn/portalCenter/api/userdata/qrCode/batchDeleteQRcode`,
    headerType: 'portal',
    method: 'get',
    params: data
  })
}

export function getStudentElectronicDocuments(data){
  return request({
    url: `https://portal-service.fdzcxy.edu.cn/portalCenter/v2/personalData/getStudentElectronicDocuments`,
    headerType: 'portal',
    method: 'get',
    params: data
  })
}


export function getTeacherElectronicDocuments(data){
  return request({
    url: `https://portal-service.fdzcxy.edu.cn/portalCenter/v2/personalData/getTeacherElectronicDocuments`,
    headerType: 'portal',
    method: 'get',
    params: data
  })
}

// 进校
export function getaccountJxScan(data){
  return request({
    url: `https://portal-service.fdzcxy.edu.cn/portalCenter/api/open/rest/mobile/v2/userdata/inOut/accountJxScan`,
    headerType: 'open',
    method: 'get',  
    params: data
  })
}
    